import { render } from "./MyCompanyPage.vue?vue&type=template&id=e470869c&ts=true"
import script from "./MyCompanyPage.vue?vue&type=script&lang=ts"
export * from "./MyCompanyPage.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\DDrive\\DeveloperFolder\\VueJsApps\\byihusemanagt\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__